import script from "./DeskNavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./DeskNavBar.vue?vue&type=script&setup=true&lang=js"

import "./DeskNavBar.vue?vue&type=style&index=0&id=4acc2954&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4acc2954"]])

export default __exports__